var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "star-top" },
    [
      _c("div", { staticClass: "star-top-bg" }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.topBg,
              expression: "!topBg",
            },
          ],
          staticClass: "star-top-bg-default",
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.topBg && _vm.searchData.detail.sogou_image,
                expression: "topBg && searchData.detail.sogou_image",
              },
            ],
            staticClass: "star-top-bg-img",
          },
          [
            _c("img", {
              attrs: { src: _vm.searchData.detail.sogou_image },
              on: {
                error: function ($event) {
                  return _vm.bgError()
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "star-top-bg-img-after" }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("TopHead", { attrs: { title: "明星" } }),
      _vm._v(" "),
      _c("div", { staticClass: "star-top-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.topBg && _vm.searchData.detail.sogou_image,
                expression: "topBg && searchData.detail.sogou_image",
              },
            ],
            staticClass: "star-top-content-img",
          },
          [
            _c("CoverImage", {
              attrs: {
                src: _vm.searchData.detail.sogou_image,
                "is-resize": false,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "star-top-content-info" }, [
          _c("h3", { staticClass: "star-name" }, [
            _vm._v("\n        " + _vm._s(_vm.searchData.star) + "\n      "),
          ]),
          _vm._v(" "),
          _vm.searchData.detail
            ? _c("div", [
                _vm.searchData.detail.work
                  ? _c("p", [
                      _vm._v(
                        "\n          职业：" +
                          _vm._s(_vm.searchData.detail.work.join(" ")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.searchData.detail.birthDate
                  ? _c("p", [
                      _vm._v(
                        "\n          生日：" +
                          _vm._s(_vm.searchData.detail.birthDate) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.searchData.detail.birth_place
                  ? _c("p", [
                      _vm._v(
                        "\n          地区：" +
                          _vm._s(_vm.searchData.detail.birth_place) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "star-bottom" }),
      _vm._v(" "),
      _c("div", { staticClass: "star-top-nav" }, [
        _c(
          "div",
          { staticClass: "star-top-nav-box" },
          _vm._l(_vm.searchData.entity, function (item, index) {
            return _c(
              "a",
              {
                key: index,
                class: item.doctype === _vm.starTab ? "cur" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeStarWorks(item, index)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(item.doctypeName) + "\n      ")]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }